'use strict';

const updatePDPHandler = require('./pages/product/updatePDPHandler');

const productPageHandler = {
    updatePage: function(data) {
        const returnConfig = {};
        const selectedComponents = data.selectedComponents;
        const product = data.product;

        const form = $('input[name="pid"][value="' + product + '"]').parents('form');
        const oldProductConfiguration = $('.js-product-configurator-trigger', form).data('productConfiguration');

        for (const componentName in selectedComponents) {
            selectedComponents[componentName].previousId = oldProductConfiguration[componentName];
            returnConfig[componentName] = selectedComponents[componentName].id;
        }

        const returnSelectedComponentsData = data.updateData && data.updateData.isTalisman ?
            createTalismanDataForPageUpdate(data, selectedComponents) : createDataForPageUpdate(data, selectedComponents);

        const dataForUpdate = {
            returnSelectedComponentsData: returnSelectedComponentsData,
            returnConfig: returnConfig,
            product: product,
            selectedComponents: selectedComponents
        };

        updatePageElements(dataForUpdate.returnSelectedComponentsData);

        updateCartButtonData(dataForUpdate);

        updateSocialCommerceElement(dataForUpdate);
    }
};

function updateSocialCommerceElement(data) {
    const $socialCommerceButton = $('.js-social-commerce-button');
    if (!$socialCommerceButton || !$socialCommerceButton.length) {
        return;
    }

    const $form = $('input[name="pid"][value="' + data.product + '"]').parents('form');
    if (!$form || !$form.length) {
        return;
    }

    const socialCommerceData = $socialCommerceButton.data('social-commerce');
    if (!socialCommerceData) {
        return;
    }

    socialCommerceData.configurationId = data.returnSelectedComponentsData.urlParams['configurationId'];
    $socialCommerceButton.data('social-commerce', socialCommerceData);

    const $addToCartButton = $('.js-add-to-cart', $form);

    if ($addToCartButton.hasClass('hide') || $addToCartButton.hasClass('btn--disabled')) {
        $socialCommerceButton.parent().addClass('hide');
        return;
    }

    $socialCommerceButton.parent().removeClass('hide');
}

function createTalismanDataForPageUpdate(data, selectedComponents) {
    const updateData = data.updateData;

    const urlParamObject = {};
    urlParamObject[updateData.urlParameterName] = String.format(updateData.urlParameterValueFormat, data.product,
        selectedComponents.fragrance.id, selectedComponents.bottle.id, selectedComponents.cap.id, selectedComponents.talisman.id);

    const returnSelectedComponentsData = {};
    returnSelectedComponentsData.urlParams = JSON.parse(JSON.stringify(urlParamObject));
    returnSelectedComponentsData.shortDescription = String.format(updateData.talismanShortDescriptionFormat, selectedComponents.bottle.longDescription,
        selectedComponents.fragrance.productUnit, selectedComponents.cap.longDescription, selectedComponents.talisman.longDescription, selectedComponents.bottle.travelBottleTitle);

    returnSelectedComponentsData.title = selectedComponents.fragrance.title;
    returnSelectedComponentsData.stickyBarTitle = selectedComponents.fragrance.stickyBarTitle;
    const primaryImageObject = updateData.talismanPrimaryImagePlaceholder;
    primaryImageObject.src = String.format(primaryImageObject.urlFormat, selectedComponents.bottle.EAN, selectedComponents.fragrance.EAN,
        selectedComponents.talisman.EAN, selectedComponents.cap.EAN);
    returnSelectedComponentsData.stickyBarImage = primaryImageObject;
    const htuImageObject = updateData.talismanHTUImagePlaceholder;
    if (htuImageObject) {
        htuImageObject.src = String.format(htuImageObject.urlFormat, selectedComponents.bottle.EAN, selectedComponents.fragrance.EAN,
            selectedComponents.talisman.EAN, selectedComponents.cap.EAN);
        returnSelectedComponentsData.howToUseImage = htuImageObject;
    }
    returnSelectedComponentsData.productLifestyleImage = selectedComponents.fragrance.productLifestyleImage;
    returnSelectedComponentsData.ingredientsBlockVideoID = selectedComponents.fragrance.ingredientsBlockVideoID;
    returnSelectedComponentsData.pdpImagesUrl = updateData.pdpImagesUrl + '&' + updateData.urlParameterName + '=' + urlParamObject[updateData.urlParameterName];
    returnSelectedComponentsData.claimableIngredients = selectedComponents.fragrance.notes;
    returnSelectedComponentsData.chemicalIngredients = selectedComponents.fragrance.chemicalIngredients;
    returnSelectedComponentsData.usp = selectedComponents.fragrance.usp;
    returnSelectedComponentsData.productDetailImage = selectedComponents.fragrance.productDetailImage;

    return returnSelectedComponentsData;
}

function createDataForPageUpdate(data, selectedComponents) {
    let presentationComponent = null;
    let mainComponent = null;
    for (const key in selectedComponents) {
        if (['fragrance', 'wax'].indexOf(key) === -1) {
            presentationComponent = selectedComponents[key];
            continue;
        }

        mainComponent = selectedComponents[key];
    }
    const updateData = data.updateData;
    const urlParamObject = {};
    urlParamObject[updateData.urlParameterName] = String.format(updateData.urlParameterValueFormat, data.product,
        mainComponent.id, presentationComponent.id);

    const returnSelectedComponentsData = {};
    returnSelectedComponentsData.title = mainComponent.title;
    returnSelectedComponentsData.stickyBarTitle = mainComponent.stickyBarTitle;
    returnSelectedComponentsData.pdpImagesUrl = presentationComponent.pdpImagesUrl;
    returnSelectedComponentsData.claimableIngredients = mainComponent.claimableIngredients;
    returnSelectedComponentsData.chemicalIngredients = mainComponent.chemicalIngredients;
    const firstPartDescription = [presentationComponent.shortDescription, presentationComponent.bottleShape,
        presentationComponent.nameColorDesign].filter(Boolean).join(' - ');

    const wholeDescription = [firstPartDescription, mainComponent.shortDescription,
        mainComponent.productUnit].filter(Boolean).join(', ');
    returnSelectedComponentsData.shortDescription = wholeDescription;
    returnSelectedComponentsData.stickyBarImage = presentationComponent.stickyBarImage;
    returnSelectedComponentsData.urlParams = JSON.parse(JSON.stringify(urlParamObject));
    returnSelectedComponentsData.howToUseImage = presentationComponent.howToUseImage;
    returnSelectedComponentsData.productLifestyleImage = presentationComponent.productLifestyleImage;
    returnSelectedComponentsData.productDetailImage = presentationComponent.productDetailImage;
    returnSelectedComponentsData.dimensions = presentationComponent.productDimensions;

    return returnSelectedComponentsData;
}

module.exports = productPageHandler;

function updatePageElements(productSelectedComponentsData) {
    updatePDPHandler.updateTitle(productSelectedComponentsData.title);
    updatePDPHandler.updateShortDescription(productSelectedComponentsData.shortDescription);
    updatePDPHandler.updateClaimableIngredients(productSelectedComponentsData.claimableIngredients);
    updatePDPHandler.updateTabsIngredients(productSelectedComponentsData.chemicalIngredients);
    updatePDPHandler.updateImages(productSelectedComponentsData.pdpImagesUrl);
    updatePDPHandler.updateStickyBarTitle(productSelectedComponentsData.stickyBarTitle);
    updatePDPHandler.updateStickyBarImage(productSelectedComponentsData.stickyBarImage);
    updatePDPHandler.updateStateAndUrlParams(productSelectedComponentsData.urlParams);
    updatePDPHandler.updateHowToUseImage(productSelectedComponentsData.howToUseImage && productSelectedComponentsData.howToUseImage.src);
    updatePDPHandler.updateProductLifestyleImage(productSelectedComponentsData.productLifestyleImage && productSelectedComponentsData.productLifestyleImage.src);
    updatePDPHandler.updateProductDetailImage(productSelectedComponentsData.productDetailImage && productSelectedComponentsData.productDetailImage.src);

    //signature and mansion specific block
    updatePDPHandler.updateUSPs(productSelectedComponentsData.dimensions);

    //talisman specific block
    updatePDPHandler.trimAndUpdateLongDescription(productSelectedComponentsData.usp);
    updatePDPHandler.updateVideoSrc('talisman-product-ingredient-video', productSelectedComponentsData.ingredientsBlockVideoID);
}

function updateCartButtonData(data) {
    const form = $('input[name="pid"][value="' + data.product + '"]').parents('form');
    updateHiddenFields(data, form);
    handleOutOfStock(form);
    updateConfiguratorButton(form, data);
}

function updateHiddenFields(data, form) {
    const childPids = $('input[name="childPids"]', form);
    const pids = Object.values(data.returnConfig).join();
    childPids.val(pids);

    const thumbnailImage = $('input[name="thumbnailImage"]', form);
    thumbnailImage.val(data.returnSelectedComponentsData.stickyBarImage.src);

    const horProducts = $('input[name="horProducts"]', form);
    if (horProducts.length > 0) {
        const dataLayerData = JSON.parse(horProducts.val());

        dataLayerData.products.forEach(function(product, i) {
            if (product.finalSku) {
                dataLayerData.products[i].finalSku = data.returnSelectedComponentsData.urlParams.configurationId;
            } else {
                for (const key in data.selectedComponents) {
                    const selectedComponent = data.selectedComponents[key];
                    if (product.sku != selectedComponent.previousId) {
                        continue;
                    }

                    dataLayerData.products[i] = selectedComponent.dataLayerData;
                }
            }
        });
        horProducts.val(JSON.stringify(dataLayerData));
    }
}

function handleOutOfStock(form) {
    const disabledAddToCart = $('.js-add-to-cart.btn--disabled.hide', form);

    if (!disabledAddToCart.length) {
        return;
    }

    disabledAddToCart.removeClass('btn--disabled hide');
    $('.js-out-of-stock-block', form).addClass('hide');
    $('.js-shipping-info.hide').removeClass('hide');
}

function updateConfiguratorButton(form, data) {
    const configuratorButton = $('.js-product-configurator-trigger');

    if (configuratorButton.length) {
        configuratorButton.data('productConfiguration', data.returnConfig);
        configuratorButton.data('productUrlParam', data.returnSelectedComponentsData.urlParams.configurationId);
    }

    const primaryConfiguratorButton = $('.js-product-configurator-trigger.btn--primary', form);

    if (!primaryConfiguratorButton.length) {
        return;
    }

    primaryConfiguratorButton.removeClass('btn--primary').addClass('btn--secondary');
}
